import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import apiClient from '../../../utils/backend'
const API_URL =
  '/api/notifications?cant_pages=10&page=1&include=treatment.dentists'

const AdminNotificationsList = ({ active, displayRedTag }) => {
  const [state, setState] = useState()
  const history = useHistory()

  const displayMotivo = (motivoId) => {
    if (motivoId === 8) return 'Solicitud de ingreso'
    if (motivoId === 9) return 'Nueva documentación'
    if (motivoId === 10) return 'Aprobación de propuesta de Tratamiento'
    if (motivoId === 11) return 'Rechazo de propuesta de Tratamiento'
  }

  useEffect(() => {
    const getNotificationsAdmin = async () => {
      try {
        const res = await apiClient(API_URL)
        setState(res.data.table)

        let pendingNotification = res.data.table.find(
          (element) => !element.read
        )

        if (pendingNotification) return displayRedTag(true)
        else displayRedTag(false)
      } catch (error) {
        console.log(error)
      }
    }

    getNotificationsAdmin()
  }, [active])

  if (!state || state.length === 0)
    return (
      <div className="d-flex">
        <div className="d-flex align-items-center justify-content-center m-auto fw-bold fs-5 text-primary">
          No hay nuevas notificaciones
        </div>
      </div>
    )

  return (
    <div className="px-2">
      {state.map((item, i) => {
        return (
          <div
            key={i}
            className="DD-notification-card cursor-pointer "
            onClick={() => {
              history.push('/admin/notificaciones')
            }}
          >
            <div className="d-flex align-items-center">
              <div
                className={item.read ? 'DD-circle-green' : 'DD-circle-yellow'}
              ></div>
              {item?.treatment?.dentists[0]?.user.avatar ? (
                <img
                  alt="avatar"
                  className="DD-avatar"
                  src={item?.treatment?.dentists[0]?.user.avatar}
                />
              ) : (
                <div className="NT-avatar"></div>
              )}
            </div>
            <div className="d-flex flex-column w-100">
              <div className="d-flex align-items-center justify-content-between">
                <p
                  className="my-0 fs-7 DD-user-name text-truncate"
                  title={
                    item?.treatment?.dentists[0]?.user.name +
                    ' ' +
                    item?.treatment?.dentists[0]?.user.surname
                  }
                >
                  {item?.treatment?.dentists[0]?.user.name +
                    ' ' +
                    item?.treatment?.dentists[0]?.user.surname}
                </p>
                <p style={{ fontSize: 10 }} className="disabled my-0">
                  {moment.utc(item.created_at).format('DD-MM-YYYY')}
                </p>
              </div>
              <div className="my-1 fw-bold">{displayMotivo(item.type)}</div>
              <div className="mt-2 disabled fs-7">{item.detail}</div>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default AdminNotificationsList
